module.exports = __webpack_public_path__ + "img/drive2.6408c1c9.png";